export default {
  signup: {
    my_comp_exhibiting: 'My company is exhibiting at the event',
    sur_un_stand_individual:
      'On an individual or shared stand (with Business France)',
    sur_un_stand_collectif:
      'On a regional or interprofessional collective stand',
    selecting_event: 'Select the event',
    selecting_collectif: 'Select the collective',
    title: 'Importer registration for Loire Wines Trade Tasting',
    subtitle: 'Account creation request:',
    form: {
      text: {
        bold: 'Contact for login creation > ',
        normal: 'Information not visible** on communication materials',
      },
      labels: {
        firstname: 'First name',
        lastname: 'Last name',
        phone: 'Phone',
        companyName: 'Company name',
        siret: 'ABN',
        email: 'Email / login',
        password: 'Choose your password',
        passwordConfirmation: 'Confirm your password',
      },
      validate: 'Validate',
      asterix: {
        required: 'Required information',
        info: 'The information requested above is used to create the account and login credentials for your company. This information will not be visible; it is kept for file management. (1 email address = 1 company account)',
      },
      success:
        'You will receive an email in a few minutes to confirm your account. Please, check your spam folder',
    },
    category_of_my_company: 'Category of my company',
    select_category: 'Select the category',
  },
};
